<mat-progress-spinner class="centerSpinner" mode="indeterminate"></mat-progress-spinner>